import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import { useTosAcceptanceQuery } from '../queries/tosAcceptance_gen'
import {
  RequestTosAcceptanceMutation,
  RequestTosAcceptanceMutationVariables,
  useRequestTosAcceptanceMutation,
} from './requestTosAcceptance_gen'

type UseRequestTosAcceptanceMutationOptions = UseGqlMutationCallbacks<
  RequestTosAcceptanceMutation,
  RequestTosAcceptanceMutationVariables
>

export const useRequestTosAcceptance = (
  orgId: number,
  mutationOptions?: UseRequestTosAcceptanceMutationOptions
) => {
  const { mutateAsync: requestTosAcceptance } = useRequestTosAcceptanceMutation()
  const optionsWithNotification = useMutationNotifier(
    { onMutate: 'Looking up your updated Terms of Service...', onSuccess: false },
    mutationOptions
  )
  return useMutationWithInvalidation(requestTosAcceptance, optionsWithNotification, [
    useTosAcceptanceQuery.getKey({ ownerId: orgId }),
  ])
}
